export {
  SessionManager,
  sessionManager,
  type Session,
  type SessionOptions,
  FrameQueryMode,
} from './session-manager.js';
